export default "__VITE_ASSET__Cy6s3Q7i__"